import { ChevronDown as ChevronDownIcon } from '~/highlight/icons';
import { bem } from '~/common/classname';
import './styles.scss';

type Props = {
  target: HTMLElement;
  children?: string;
  title?: string;
  logo?: string;
  onClose: () => void;
};

type StateType = {
  children?: string;
  [key: string]: any;
};

class Modal {
  props: Props;
  state: StateType;
  onClickAway: (event: MouseEvent) => void;

  constructor(props: Props) {
    this.props = { ...props };
    this.state = { children: this.props.children ?? '' };
    this.onClickAway = this.handleClickAway.bind(this);
  }

  template(): string {
    return /*html*/ `
      <div class="${bem([`bai-highlight-modal-wrapper`])}">
        <div class="${bem([`bai-highlight-modal`, 'header'])}">
          <div class="${bem([`bai-highlight-modal`, 'header', 'label'])}">
            ${
              this.props.logo
                ? /*html*/ `<img alt="" src="${this.props.logo}" class="${bem([
                    `bai-highlight-modal`,
                    'header',
                    'logo',
                  ])}" />`
                : ''
            }
            <h2 class="${bem([
              `bai-highlight-modal`,
              'header',
              'title',
            ])}"><span>AI</span> ${this.props.title}</h2>
          </div>
          <button class="${bem([`bai-highlight-modal`, 'close'])}">
            ${ChevronDownIcon}
          </button>
        </div>
        <div class="${bem([`bai-highlight-modal`, 'main'])}">
          ${this.state.children ?? ''}
        </div>
      </div>
    `;
  }

  render() {
    const div = document.createElement('div');
    div.className = bem([`bai-highlight-modal`]);
    div.innerHTML = this.template();
    this.props.target.appendChild(div);
    this.setup();
  }

  setup() {
    const container = document.querySelector(
      `.${bem([`bai-highlight-modal`])}`
    );
    const closeButton = document.querySelector(
      `.${bem([`bai-highlight-modal`, 'close'])}`
    );
    container?.addEventListener('click', this.onClickAway);
    closeButton?.addEventListener('click', this.props.onClose);
  }

  unmount(): void {
    const container = document.querySelector<HTMLDivElement>(
      `.${bem([`bai-highlight-modal`])}`
    );
    const closeButton = document.querySelector(
      `.${bem([`bai-highlight-modal`, 'close'])}`
    );
    container?.removeEventListener('click', this.onClickAway);
    closeButton?.removeEventListener('click', this.props.onClose);

    container?.remove();
  }

  /* --------------------------------- event handlers -------------------------------- */

  handleClickAway(event: MouseEvent) {
    const { target } = event;
    if ((<HTMLElement>target).matches(bem([`.bai-highlight-modal`]))) {
      this.props.onClose && this.props.onClose();
    }
  }

  /* -------------------------------------------------------------------------- */

  setState(newState: StateType) {
    this.state = { ...this.state, ...newState };
    this.render();
  }
}

export default Modal;
